import h from 'hyperscript';

import infoIcon from '@disy/cadenza-icons/info.svg';
import { icon } from '@disy/ui/icon';

import { getStore } from 'cadenza/store/cadenza-store';
import { isWorkbookFeatureAvailable } from 'cadenza/workbook/workbook-features';
import i18n from 'cadenza/workbook/workbook-print-header/workbook-print-header.properties';

import './workbook-print-header.css';

export function makeSurePrintingIsTriggeredFromApplication() {
  // When the printing is triggered from within application on the top html element there is a class
  // called print-layout--main. If that is not a case, we show a warning message that the printing
  // should be done from the application.
  if (!document.documentElement.classList.contains('print-layout--main')) {
    /* Due to performance issues with has() in Chrome (see CADENZA-41429), we use an explicit marker added to the body */
    document.body.classList.add('.has-d-printing-not-triggered-from-application-warning');

    document.body.prepend(createPrintingNotTriggeredFromApplicationWarningElement());
  }
}

export function removeWarningElement() {
  document.body.classList.remove('.has-d-printing-not-triggered-from-application-warning');

  // Optional chaining because there will not always be a warning message.
  document.querySelector('.d-printing-not-triggered-from-application-warning')?.remove();
}

function createPrintingNotTriggeredFromApplicationWarningElement() {
  const mainClass = '.d-printing-not-triggered-from-application-warning';

  if (!isWorkbookFeatureAvailable(getStore().getState(), 'workbook-print-worksheet')) {
    return h(
      mainClass,
      h(mainClass + '--header', icon(infoIcon), i18n('simplifiedMode.header')),
      h(mainClass + '--title', i18n('simplifiedMode.title')),
    );
  }

  return h(
    mainClass,
    h(mainClass + '--header', icon(infoIcon), i18n('header')),
    h(mainClass + '--title', i18n('title')),
    h(mainClass + '--message', i18n('message')),
  );
}
